import $ from 'jquery';

function toParamString(obj) {
  return Object.keys(obj).filter((key) => obj[key] !== '')
    .map((key) => `${key}=${obj[key]}`)
    .join('&')
}

function makeRequeryUrl(docid, currParamString) {
  const blacklist = ['m'];

  const params = currParamString
    .slice(1)
    .split('&')
    .map((keyValue) => {
      const [key, val] = keyValue.split('=');
      return {key, val};
    })
    .filter((param) => !blacklist.includes(param.key))
    .filter((param) => param.val.length > 0)
    .map((param) => ({[param.key]: param.val}))
    .reduce((acc, curr) => $.extend({}, acc, curr), {});

  const extendedParams = $.extend({}, params, {
    w: 'img',
    DA: 'IIM',
    docid
  });

  return `?${toParamString(extendedParams)}`;
}

export default makeRequeryUrl;



/** WEBPACK FOOTER **
 ** ./src/IIM/core/utils/makeRequeryUrl.js
 **/